/**
 * @fileoverview Cell renderer for the POD claims schedule money columns.
 *
 * Split out of `podClaimsColumns.tsx` (react-refresh/only-export-components).
 */

import { cn } from "@/utils/misc";
import { fmtMoneyShort } from "./podShared";

/**
 * One money figure. `null` renders as an em dash — the proof-split columns are
 * deliberately empty where the class does not apply (no security held, nothing
 * ranking preferentially).
 */
export function Money({
  value,
  bold,
  muted,
  flagged,
  note,
  title,
}: {
  value: number | null;
  bold?: boolean;
  muted?: boolean;
  /** Amber the figure — it is real, but it cannot be relied on at face value. */
  flagged?: boolean;
  /** Short caption under the figure, e.g. why it cannot be relied on. */
  note?: string;
  title?: string;
}) {
  if (value === null) {
    return <span className="text-sm text-muted-foreground">—</span>;
  }

  return (
    <>
      <span
        className={cn(
          "font-mono text-sm tabular-nums",
          bold && "font-semibold",
          flagged
            ? "text-amber-700 dark:text-amber-400"
            : muted && "text-muted-foreground",
        )}
        title={title}
      >
        {fmtMoneyShort(value)}
      </span>
      {note && (
        <p
          className={cn(
            "mt-1 text-[10px] font-medium leading-tight",
            flagged
              ? "text-amber-700 dark:text-amber-400"
              : "text-muted-foreground",
          )}
          title={title}
        >
          {note}
        </p>
      )}
    </>
  );
}
